import {
  FRAMEWORKS_SUGGESTIONS_COLLAPSED_LIMIT,
  FRAMEWORKS_SUGGESTIONS_LIMIT
} from "PFApp/constants/activity_form/skills_frameworks_limits";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers";
import { SkillsFramework } from "PFCore/types";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./skills_frameworks_suggestions.module.scss";

export type SkillsFrameworksSuggestionsProps = {
  isDisabled?: boolean;
  onSuggestionClick: (skillsFramework: SkillsFramework) => void;
  suggestions: SkillsFramework[];
  showMoreButton?: boolean;
};

export const SkillsFrameworksSuggestions = ({
  isDisabled = false,
  onSuggestionClick,
  suggestions,
  showMoreButton = false
}: SkillsFrameworksSuggestionsProps) => {
  const { t } = useTranslation("core");
  const [showMoreSuggestions, setShowMoreSuggestions] = useState(false);

  const filteredSuggestions = useMemo(
    () =>
      suggestions.slice(
        0,
        showMoreSuggestions ? FRAMEWORKS_SUGGESTIONS_LIMIT : FRAMEWORKS_SUGGESTIONS_COLLAPSED_LIMIT
      ),
    [showMoreSuggestions, suggestions]
  );

  const hasMoreSuggestions = showMoreButton && suggestions.length > filteredSuggestions.length;

  return (
    <Stack gap="spacingSm">
      {filteredSuggestions.map((suggestion) => (
        <Button
          className={css.suggestion}
          key={suggestion.id}
          text={suggestion.name}
          kind="secondary"
          icon="add"
          disabled={isDisabled}
          onClick={() => onSuggestionClick(suggestion)}
        />
      ))}
      {hasMoreSuggestions && (
        <Button
          className={css.suggestion}
          disabled={isDisabled}
          kind="text"
          text={t("showMore")}
          onClick={() => setShowMoreSuggestions(true)}
        />
      )}
    </Stack>
  );
};
